import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../login/AuthProvider";
import { extend } from "../../components/apipath";
import Swal from "sweetalert2";

function ExtendRequestForm() {

    const { token, mem_id, mem_status, authorized } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!authorized || String(mem_status) !== "1") {
            Swal.fire({
                icon: 'warning',
                title: '學員專屬功能',
                text: '此頁面僅限學員使用，請先完成購買',
                confirmButtonText: '了解',
                confirmButtonColor: '#224040',
            }).then(() => {
                navigate('/');
            });
        }
    }, []);

    const [formData, setFormData] = useState({
        studentName: "",
        subject: [],
        proofFile: null,
        currentExpiry: "",
        requestedExpiry: "",
        memo: "",
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        const authData = JSON.parse(localStorage.getItem("auth"));
        if (authData && authData.chinese_name) {
            setFormData((prevData) => ({
                ...prevData,
                studentName: authData.chinese_name,
            }));
        }
    }, []);

    // 處理文字、日期輸入
    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
        setFormData({
            ...formData,
            [name]: type === "file" ? files[0] : value,
        });
    };

    // 處理科目多選框
    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        setFormData((prevData) => {
            const updatedSubjects = checked
                ? [...prevData.subject, value]
                : prevData.subject.filter((subject) => subject !== value);

            return {
                ...prevData,
                subject: updatedSubjects,
            };
        });
    };

    // 處理單檔案選擇
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        // console.log("選取的檔案：", file);
    
        setFormData(prevState => ({
            ...prevState,
            proofFile: file,
        }));
    };

    // 處理表單提交
    const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
        const uploadedFilePath = await handleFileUpload(formData.proofFile); // 先上傳檔案

        const dataToSend = {
            mem_id: mem_id,
            student_name: formData.studentName,
            subject: formData.subject.join(","), // 轉成字串
            proof_file: uploadedFilePath, // 檔案路徑
            status: '審核中',
            current_expiry: formData.currentExpiry,
            requested_expiry: new Date(new Date(formData.currentExpiry).setMonth(new Date(formData.currentExpiry).getMonth() + 6)).toISOString().split("T")[0],
            memo: formData.memo,
        };

        // console.log("送出的資料:", dataToSend);

        const response = await axios.post(`${extend}`, dataToSend, { headers: { token } });

        if (response.status === 200) {
            Swal.fire({
                icon: "success",
                title: "申請成功",
                text: "請等待管理員審核！",
                confirmButtonText: "確認",
                timer: 3000, // 3秒後自動關閉
                timerProgressBar: true,
                willClose: () => {
                    window.location.href = '/member';
                }
            });
        }
    } catch (error) {
        console.error("申請失敗:", error);
    
        const errorMessage = error.response?.data?.message || "提交失敗，請稍後再試。";
    
        Swal.fire({
            icon: "error",
            title: "申請失敗",
            text: errorMessage,
            confirmButtonText: '確定',
        });
    }

    setIsSubmitting(false);
};
const handleFileUpload = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
        const response = await axios.post(`${extend}upload`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });

        // console.log("上傳成功，檔案路徑:", response.data.filePath); // 🛠 確保 filePath 存在

        if (response.status === 200) {
            return response.data.filePath; // 確保這裡有回傳值
        } else {
            throw new Error("檔案上傳失敗");
        }
    } catch (error) {
        console.error("檔案上傳失敗:", error);
        throw new Error("檔案上傳失敗");
    }
};

    return (
        <div className="container mb100 mt100">
            <h2 className="font-weight-bold pb-5 text-center">會員軟體展延申請</h2>
            <div className="card w-75 p-5 m-auto">
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        {/* 學員姓名 */}
                        <div className="form-group mb-4">
                            <label>學員姓名</label>
                            <input type="text" className="form-control" name="studentName" value={formData.studentName} readOnly />
                        </div>

                        {/* 欲申請展延的科目 */}
                        <div className="form-group mb-4">
                            <label>欲申請展延的科目</label>
                            <div className="checkbox-group">
                                {["FAR", "REG", "AUD", "BAR", "TCP", "ISC"].map((subject) => (
                                    <div className="form-check" key={subject}>
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="subject"
                                            value={subject}
                                            checked={formData.subject.includes(subject)}
                                            onChange={handleCheckboxChange}
                                        />
                                        <label className="form-check-label">{subject}</label>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* 證明文件上傳 */}
                        <div className="form-group mb-4">
                            <label>證明文件上傳</label>
                            <input type="file" className="form-control" name="proofFile" onChange={handleFileChange} accept=".pdf,.jpg,.png" required />
                        </div>

                        {/* 軟體到期日 */}
                        <div className="form-group mb-4">
                            <label>目前軟體到期日</label>
                            <input type="date" className="form-control" name="currentExpiry" value={formData.currentExpiry} onChange={handleChange} required />
                        </div>

                        {/* 備註 */}
                        <div className="form-group mb-4">
                            <label>備註</label>
                            <textarea className="form-control" name="memo" rows="3" value={formData.memo} onChange={handleChange} />
                        </div>

                        {/* 提交按鈕 */}
                        <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>
                            {isSubmitting ? "提交中..." : "提交申請"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ExtendRequestForm;
